import { AppRoutes, UserSettingsNestedRoutes } from 'src/types';
import {
  CirclesThreePlus,
  PlugsConnected,
  UserCircle,
} from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { NavigationItem } from 'src/v2/components/LeftSidePanel/components/UserMenuSection/components/NavigationItem';

export const ManageAccountButtons = () => {
  const buttons = [
    {
      disabled: false,
      title: 'Profile',
      route: `${AppRoutes.MANAGE_ACCOUNT}/${UserSettingsNestedRoutes.PROFILE}`,
      icon: <UserCircle size={SVG_SIZE_M} />,
      isVisible: true,
    },
    {
      disabled: false,
      title: 'On-demand',
      route: AppRoutes.ADD_ON,
      icon: <CirclesThreePlus size={SVG_SIZE_M} />,
      isVisible: true,
    },
    {
      disabled: false,
      title: 'Integrations',
      route: `${AppRoutes.MANAGE_ACCOUNT}/${UserSettingsNestedRoutes.INTEGRATIONS}`,
      icon: <PlugsConnected size={SVG_SIZE_M} />,
      isVisible: true,
    },
  ];

  return (
    <>
      {buttons.map((button) => (
        <NavigationItem key={button.route} item={button} />
      ))}
    </>
  );
};
